export const language = {
    dialog: {
        settings: {
            header: "Settings",
            items: {
                motion: {
                    label: "Reduced Motion",
                },
                contrast: {
                    label: "High Contrast Mode",
                },
            },
        },
    },
    footer: {
        copyright: {
            label: "all rights reserved!",
        },
    },
    sidebar: {
        sitemap: {
            header: "Sitemap",
        },
    },
};
